/* eslint-disable no-restricted-globals */
import { PropsWithChildren, useEffect } from 'react';

import { createGlobalStyle, x } from '@/style';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: transparent;
    height: auto;
    width: auto;
  }
`;
const SizeContainer = ({ children }: PropsWithChildren) => (
  <x.div id='resize-container'>{children}</x.div>
);
export const ComponentLayout = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    let prev: number | null = null;
    function sendHeight() {
      if (parent.postMessage) {
        // replace #wrapper with element that contains
        // actual page content
        const container = document.getElementById('resize-container');
        if (container) {
          const height = container.offsetHeight;
          if (prev !== height) {
            prev = height;
            parent.postMessage(height, '*');
          }
        }
      }
    }

    const container = document.getElementById('resize-container');
    if (container) {
      new ResizeObserver(sendHeight).observe(container);
    }

    // Create browser compatible event handler.
    const eventMethod = (window.addEventListener as any)
      ? 'addEventListener'
      : 'attachEvent';
    const eventer = window[eventMethod];
    const messageEvent =
      eventMethod === 'attachEvent' ? 'onmessage' : 'message';

    // Listen for a message from the iframe.
    eventer(
      messageEvent,
      (e) => {
        if (Number.isNaN(e.data)) return;

        sendHeight();
      },
      false
    );
  }, []);
  return (
    <>
      <GlobalStyle />
      <SizeContainer>{children}</SizeContainer>
    </>
  );
};
